import MenuFrame from "../frames/menu_frame";
import { deskCnDelete, deskCnPayment, getDayBookingEdit, getDayZeroBooking, getTotalAmountDayBooking } from "./edit_halper";
import { Backdrop, Button, CircularProgress, createTheme, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, ThemeProvider, Typography } from "@mui/material";
import { dateUsaToInd, getCurrentDate, getCurrentMonthStart } from "../frames/common";
import { useState } from "react";
import { calcTotalDesk } from "../booking/booking_halper";
import { DeleteTwoTone, Edit } from "@mui/icons-material";
import CreditCardOffTwoToneIcon from '@mui/icons-material/CreditCardOffTwoTone';
import CreditScoreTwoToneIcon from '@mui/icons-material/CreditScoreTwoTone';
import Loading2 from "../frames/loading2";
import { blueGrey, green, orange, red } from "@mui/material/colors";
import WarningConfirm from "../frames/waring_confirm";
import DateEditDay from "./date_edit_day";
import PriceEditDay from "./price_edit_day";

const cu_date = getCurrentDate();
let allCns = [];

function DeskCnEdit() {
    const [isLoading, setIsLoading] = useState(false);
    const [cnList, setCnList] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [ledgerPost, setLedgerPost] = useState(false);
    const [activeConsignment, setActiveConsignment] = useState(null);
    const [fieldEdit, setFieldtEdit] = useState(false);
    const [error, setError] = useState("");
    const dayTheme = createTheme();

    const initData = async (auth) => {
        if (!auth) return;
        try {
            const res = await getDayBookingEdit({ interval: "month" });
            allCns = res;
            setCnList(res);
        } catch (error) {
            setCnList([]);
        }
    }

    const handleSpanChange = (e) => {
        setIsLoading(true);
        getDayBookingEdit({ interval: e.target.value }).then((res) => {
            allCns = res;
            setCnList(res);
            setIsLoading(false);
        }).catch((err) => {
            console.error(err);
            setCnList([]);
            setIsLoading(false);
        });
    }

    const valiidateCns = () => {
        const ladger_date = cnList[0].created;
        const post_cn_list = [];
        for (let idx = 0; idx < cnList.length; idx++) {
            const itm = cnList[idx]
            if (itm.created !== ladger_date) {
                return [];
            }
            const totl_amt = parseFloat(calcTotalDesk(itm));
            if (!itm.payment && totl_amt !== 0) post_cn_list.push(itm.cn_no)
        }
        return post_cn_list;
    }

    const initLadgerPost = () => {
        if (isLoading || cnList.length === 0) return;
        if (valiidateCns().length === 0)
            setError("All consignments must have the same date. Please select consignments from a single date which are not paid.");
        else
            setLedgerPost(true);
    }

    const postToLedger = () => {
        if (isLoading || cnList.length === 0) return;
        const ladger_date = cnList[0].created;
        const _json = { "cns": valiidateCns(), "date": ladger_date }
        setIsLoading(true);
        deskCnPayment(_json).then((_) => {
            allCns = [];
            setCnList(cnList.map((itm) => {
                if (_json.cns.includes(itm.cn_no)) {
                    itm.payment = 1;
                }
                return itm;
            }));
            setIsLoading(false);
        }).catch((err) => {
            console.error(err);
            setIsLoading(false);
        });
    }

    const deleteCn = () => {
        if (isLoading) return;
        setFieldtEdit("");
        const cn = activeConsignment.cn_no;
        setIsLoading(true);
        deskCnDelete(cn).then((_) => {
            allCns = allCns.filter((itm) => {
                if (itm.cn_no !== cn) return itm;
                return false;
            });
            setCnList(cnList.filter((itm) => {
                if (itm.cn_no !== cn) return itm;
                return false;
            }));
            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);
        });
    }

    const handleTimeChange = (event, start) => {
        if (event.target.value === "") return;
        const _json = { interval: null, start: startTime ?? dateUsaToInd(getCurrentMonthStart()), end: endTime ?? dateUsaToInd(cu_date) };
        const n_date = dateUsaToInd(event.target.value);
        if (start) {
            setStartTime(n_date);
            _json["start"] = n_date;
        } else {
            setEndTime(n_date);
            _json["end"] = n_date;
        }
        setIsLoading(true);
        getDayBookingEdit(_json).then((res) => {
            allCns = res;
            setCnList(res);
            setIsLoading(false);
        }).catch((err) => {
            console.error(err);
            setCnList([]);
            setIsLoading(false);
        });
    }

    const filterCns = (search) => {
        const tmp = allCns.filter((itm) => itm.cn_no.startsWith(search.target.value.trim()));
        if (tmp.length === 0) setCnList(allCns);
        else setCnList(tmp);
    }

    const handleClose = () => {
        setActiveConsignment(null);
        setFieldtEdit(null);
    };

    const handleEditSuccess = (json) => {
        console.log(json);

        let index = -1;
        for (let idx = 0; idx < cnList.length; idx++) {
            if (cnList[idx].cn_no === json.cn) {
                index = idx;
                break;
            }
        }
        if (index === -1) return;
        let tmp = cnList;
        if (json.task === "location") {
            tmp[index].pincode = json.pincode;
            tmp[index].address = json.address;
            tmp[index].country = json.country;
            tmp[index].destination = json.destination;
        } else if (json.task === "weight") {
            tmp[index].weight = json.weight;
            tmp[index].type = json.type;
            tmp[index].method = json.method;
        } else if (json.task === "price") {
            tmp[index].amount = Number(json.amount);
            tmp[index].other = Number(json.other);
            tmp[index].pickup = Number(json.pickup);
            tmp[index].packaging = Number(json.packaging);
            tmp[index].insurance = Number(json.insurance);
            tmp[index].fuel = Number(json.fuel);
            tmp[index].gst = Number(json.gst);
        } else if (json.task === "date") {
            tmp[index].created = json.created;
        } else if (json.task === "delete") {
            tmp.splice(index, 1);
        }
        setCnList(tmp);
    }

    const loadZeroBooking = () => {
        setIsLoading(true);
        getDayZeroBooking().then((res) => {
            allCns = res;
            setCnList(res);
            setIsLoading(false);
        }).catch((err) => {
            console.error(err);
            setCnList([]);
            setIsLoading(false);
        });
    };

    return (
        <MenuFrame permission="BOOKING_DESK" onSearch={filterCns} screen="DESK_EDIT" onInit={initData}>
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <WarningConfirm open={fieldEdit === "delete-cn"} title={"Delete consignment " + activeConsignment?.cn_no ?? ""} text={"Are you sure you want to delete this consignments? This action cannot be undone."} color="error" success_text="Delete" onSuccess={() => { deleteCn() }} onClose={() => { setFieldtEdit(""); setActiveConsignment(null); }} />
            <WarningConfirm open={ledgerPost} title={"Posting consignments into ledger"} text={"All bookings are now being posted to the ledger. After this, no further edits will be allowed."} onSuccess={() => { setLedgerPost(false); postToLedger(); }} onClose={() => { setLedgerPost(false); }} success_text="Post to Ledger" />
            <WarningConfirm open={error !== ""} title={"Message"} text={error} onSuccess={() => { setError(""); }} onClose={() => { setError(""); }} color="warning" />
            <DateEditDay data={activeConsignment} open={fieldEdit === "date"} handleClose={handleClose} onSuccess={handleEditSuccess} />
            <PriceEditDay data={activeConsignment} open={fieldEdit === "price"} handleClose={handleClose} onSuccess={handleEditSuccess} />
            <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <FormControl fullWidth>
                        <InputLabel id="time-span">Span</InputLabel>
                        <Select
                            autoFocus
                            labelId="time-span"
                            id="time-span"
                            label="Time Span"
                            defaultValue={"month"}
                            onChange={handleSpanChange}
                        >
                            <MenuItem value={""}>None</MenuItem>
                            <MenuItem value={"day"}>Day</MenuItem>
                            <MenuItem value={"month"}>Month</MenuItem>
                            <MenuItem value={"last-month"}>Last Month</MenuItem>
                            <MenuItem value={"fy"}>Fiscal Year</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="start_date" type="date" fullWidth defaultValue={getCurrentMonthStart()} slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} placeholder="Start Date" onChange={(e) => { handleTimeChange(e, true) }} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="end_date" type="date" fullWidth defaultValue={cu_date} slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} placeholder="End Date" onChange={(e) => { handleTimeChange(e, false) }} />
                </Grid>
                <Grid size={{ xs: 6, sm: 4 }}>
                    <Button onClick={initLadgerPost} style={{ textTransform: "none" }} variant="outlined" color="success" startIcon={<CreditScoreTwoToneIcon />}>Post to Ledger</Button>
                </Grid>
                <Grid size={{ xs: 6, sm: 4 }}>
                    <Button onClick={loadZeroBooking} style={{ textTransform: "none" }} variant="outlined" color="secondary" startIcon={<CreditCardOffTwoToneIcon />}>Zero Bookings</Button>
                </Grid>
            </Grid>

            <Typography variant="body2" color="textPrimary">{cnList?.length ?? 0} booking pending to post in ledger of value ₹ {getTotalAmountDayBooking(cnList)}</Typography>

            <TableContainer component={Paper}>
                <Table size="small" stickyHeader aria-label="Consignments" className="nowrap">
                    <TableHead>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { fontWeight: "bold", backgroundColor: "background.th" } }}>
                            <TableCell>Date</TableCell>
                            <TableCell>Consignment</TableCell>
                            <TableCell>Address</TableCell>
                            <TableCell align="right">Weight(Grm)</TableCell>
                            <TableCell align="right">Total</TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="right">PPI</TableCell>
                            <TableCell align="right">Fuel</TableCell>
                            <TableCell align="right">GST</TableCell>
                        </TableRow>
                    </TableHead>
                    <ThemeProvider theme={dayTheme}>
                        <TableBody>
                            {cnList === null ? <TableRow><TableCell colSpan={13}><Loading2 /></TableCell></TableRow> :
                                cnList.length === 0 ?
                                    <TableRow><TableCell colSpan={13} style={{ textAlign: "center" }}><Typography variant="subtitle2" color="textDisabled">No data to display</Typography></TableCell></TableRow> :
                                    cnList.map((row, idx) =>
                                        <TableRow
                                            key={idx}
                                            sx={{ backgroundColor: row.amount === 0 ? orange[50] : row.payment === 1 ? blueGrey[50] : row.cancel === 1 ? red[50] : green[50] }}
                                            onClick={(e) => {
                                                setActiveConsignment(row);
                                            }}
                                        >
                                            <TableCell>
                                                <Typography variant="body2">{row.created} {row.payment || row.cancel ? "" : <IconButton onClick={() => { setFieldtEdit("date"); }} ><Edit fontSize="small" /></IconButton>} </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2">{row.cn_no} {row.payment || row.cancel ? "" : <IconButton onClick={() => { setFieldtEdit("delete-cn"); }}><DeleteTwoTone fontSize="small" color="error" titleAccess={"Delete"} /></IconButton>}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2">{row.destination} - {row.pincode}</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="body2">{row.weight}</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="body2" color="primary">{row.payment || row.cancel ? "" : <IconButton onClick={() => { setFieldtEdit("price"); }} ><Edit fontSize="small" /></IconButton>} {calcTotalDesk(row)}</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="body2" color="primary">{(row.amount).toFixed(2)}</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="body2" color="primary">{(row.pickup + row.packaging + row.other + row.insurance).toFixed(2)}</Typography>
                                            </TableCell>
                                            <TableCell align="right"><Typography variant="body2" color="primary">{row.fuel.toFixed(2)}</Typography></TableCell>
                                            <TableCell align="right"><Typography variant="body2" color="primary">{row.gst.toFixed(2)}</Typography></TableCell>
                                        </TableRow>
                                    )
                            }
                        </TableBody>
                    </ThemeProvider>
                </Table>
            </TableContainer>
            <Typography variant="caption" color="textSecondary">Insurance includng 18% GST</Typography>
        </MenuFrame>
    );
}

export default DeskCnEdit;